export default "__VITE_ASSET__DCyv0mEt__"